// extracted by mini-css-extract-plugin
export default {"button":"MyCardButton_button__VIAmA","inactive":"MyCardButton_inactive__zaz+C","secondaryBtn":"MyCardButton_secondaryBtn__2acXk","icon":"MyCardButton_icon__6Y+CA"};